import { useDispatch } from "react-redux";
import {
  chatSidebarToggle,
  menuToggle,
} from "../../features/toggle/toggleSlice";
import { useLocation, useNavigate } from "react-router-dom";
const MenuToggler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  // menu togggle handler
  const menuToggleHandler = () => {
    dispatch(menuToggle());
  };

  const chatToggleHandler = () => {
    dispatch(chatSidebarToggle());
  };

  return (
    <>
      <div className="mb-4 ms-0 show-1023 d-flex justify-content-between">
        <button
          onClick={menuToggleHandler}
          type="button"
          className="theme-btn toggle-filters"
        >
          <span className="flaticon-menu-1"></span> Menu
        </button>
        {pathname.includes("messages") && (
          <button
            onClick={chatToggleHandler}
            type="button"
            className="theme-btn toggle-filters"
          >
            <span className="flaticon-chat"></span> Chats
          </button>
        )}
      </div>
      <div className="ms-0 d-flex justify-content-between">
        {pathname.includes("location") && (
          <button
            onClick={() => navigate(-1)}
            className="theme-btn toggle-filters"
          >
            <span className="flaticon-chat"></span> Volver al chat
          </button>
        )}
      </div>
    </>
  );
};

export default MenuToggler;
